module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.0@core-js/library/modules/_add-to-unscopables.js
// module id = 431
// module chunks = 0 1